import * as React from 'react';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';
import { Checkbox } from 'components/action';

// Styles
const s = require('./../LeadQuestions.css');

// Props
interface IQuestionOptionCheckboxProps {
  onChange: (changed: { checked: boolean; value: any }) => void;
  optionsTable: string;
  options: Array<{ id: any; name: string }>;
  value: any[];
}

// Component
@observer
export class QuestionOptionCheckbox extends React.Component<
  IQuestionOptionCheckboxProps,
  {}
> {
  constructor(props: IQuestionOptionCheckboxProps) {
    super(props);
  }

  public render() {
    return this.props.options !== null && this.props.options.length > 0 ? (
      <div
        className={classNames(
          s.checkboxesList,
          'options_from_' + this.props.optionsTable
        )}
      >
        {this.props.options.map((option, i) => {
          return (
            <Checkbox
              key={`option-${i}`}
              onChange={this.handleCheckboxChange}
              label={option.name}
              value={option.id}
              valueUnchecked={option.id}
              checked={
                this.props.value !== null &&
                typeof this.props.value.length !== 'undefined'
                  ? this.props.value.indexOf(option.id) !== -1
                  : false
              }
            />
          );
        })}
      </div>
    ) : null;
  }

  private handleCheckboxChange = (checked: boolean, value: any) => {
    if (this.props.onChange) {
      this.props.onChange({
        checked,
        value,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionCheckbox.tsx